export type SearchStore = {
  query: string;
};
export const initSearch = () => {
  const query = new URL(window.location.href).searchParams.get("q") ?? "";

  window.Alpine.store("search", {
    query: query,
  });

  const searchStore = window.Alpine.store("search") as SearchStore;

  Alpine.effect(() => {
    const url = new URL(window.location.href);
    url.searchParams.set("q", searchStore.query);

    if (!searchStore.query) {
      url.searchParams.delete("q");
    }
    barba.history.add(url.toString(), "barba", "replace");
  });

  window.Alpine.magic("search", () => searchStore);
};

declare module "alpinejs" {
  interface Magics<T> {
    $search: SearchStore;
  }
}
